export { ReactComponent as ArrowNextIcon } from "assets/icons/icon-arrow-right.svg";
export { ReactComponent as SearchSvg } from "assets/icons/menus/icon-search.svg";
export { default as ImageProfileBg } from "assets/images/bg-main.jpg";
export { default as ImageAvatarUser } from "assets/images/profile/avt.png";
export { default as LogoCurrency_1 } from "assets/images/providers/currency-1.png";

export const FORMAT_DATE = "DD/MM/YYYY HH:mm";

export const LIVECHAT =
  "https://tawk.to/chat/67a30e65825083258e102f88/1ijaf0g2r";
